/** Marks the one bundle whose Grab button is filled on the purchase page. */
import { Star } from 'lucide-react';

import './gift-pass-bundles-list.css';

export function GiftPassBundlePromotedBadge() {
  return (
    <span className="gpb-promoted">
      <Star size={9} strokeWidth={3} aria-hidden="true" />
      Promoted
    </span>
  );
}
